import { tuple } from '../../utils/utils'

export const collectionTypes = tuple([
  'highlights',
  'schedule',
  'episodes',
  'bonus',
  'carousel'
])
export type CollectionType = (typeof collectionTypes)[number]
export const isCollectionType = (x: any): x is CollectionType =>
  collectionTypes.includes(x)
